import { createSelector, createStructuredSelector } from 'reselect';
import { filter, reject, orderBy, negate, isEmpty } from 'lodash/fp';

const contentsSelector = state => state.data.contents;
const journeyContentsSelector = state => state.data.journeyContents;

export const allAssignmentsSelector = createSelector(
  contentsSelector,
  filter('context.assignedDirectly'),
);

export const hasAssignments = createSelector(
  allAssignmentsSelector,
  negate(isEmpty),
);

export const awaitingGradeAssignments = createSelector(
  allAssignmentsSelector,
  filter('progress.gradePending'),
);

export const completedAssignments = createSelector(
  allAssignmentsSelector,
  filter(
    assignment =>
      assignment.progress.completedDate && !assignment.progress.gradePending,
  ),
);

export const completedJourneyAssignments = createSelector(
  journeyContentsSelector,
  filter('progress.completedAt'),
);

export const incompleteAssignments = createSelector(
  allAssignmentsSelector,
  reject('progress.completedDate'),
);

export const incompleteJourneyAssignments = createSelector(
  journeyContentsSelector,
  reject('progress.completedAt'),
);

const incompleteAssignmentsSorted = createSelector(
  incompleteAssignments,
  orderBy(['progress.dueDate', 'progress.assignedDate'], ['asc', 'desc']),
);

export const hasIncompleteAssignments = createSelector(
  incompleteAssignments,
  negate(isEmpty),
);

export const hasIncompleteJourneyAssignments = createSelector(
  incompleteJourneyAssignments,
  negate(isEmpty),
);

export const hasAnyIncompleteAssignments = createSelector(
  [hasIncompleteAssignments, hasIncompleteJourneyAssignments],
  (assignments, journeyAssignments) => {
    if (assignments || journeyAssignments) {
      return true;
    }
    return false;
  },
);

export const allAssignmentsByType = createStructuredSelector({
  awaitingGrade: awaitingGradeAssignments,
  completed: completedAssignments,
  incomplete: incompleteAssignmentsSorted,
});

export const allJourneyAssignmentsByType = createStructuredSelector({
  incomplete: incompleteJourneyAssignments,
  completed: completedJourneyAssignments,
});
